import IncompleteIcon from 'Assets/icons/incomplete.svg?react'
import CompleteIcon from 'Assets/icons/complete.svg?react'

export const createSidebarIcon = (
    AntdIcon: React.ForwardRefExoticComponent<{ style?: React.CSSProperties }>
): React.FC<{ color: string }> => {
    return (props: { color: string }) => {
        return <AntdIcon style={{ color: props.color }} />
    }
}

export const getIconBasedOnCompletionPercentage = (
    completionPercentage: { percent: number } | null
) => {
    if (!completionPercentage) {
        return null
    }
    if (completionPercentage.percent < 100) {
        return <IncompleteIcon />
    }
    return <CompleteIcon />
}
